import React from 'react';
import './Body.css';

const Body = ({ elements }) => {
    const date = new Date();  
    return (<body>
        <header className='header-container'>
            <a href="/" className="tan-anchor">
                <img src="images/1920x598 Black.png" alt="Gridient Logo" className="logo-image"></img>
            </a>
        </header>
        <div className="page-content">
            {elements}
        </div>
        <footer className='footer-container'>
            <a href="/" className="tan-anchor">
                <img src="images/1920x598 Black.png" alt="Gridient Logo" className="logo-image"></img>
            </a>
            <div className='footer-content'>
            <div className="footer-text">
                <p>© {date.getFullYear()} Gridient. All rights reserved.</p>
                <a href="/privacy_policy" className="tan-anchor" target="_blank">
                <p>Privacy Policy</p>
                </a>
            </div>
            </div>
        </footer>
    </body>

    );
};

export default Body;
